export const areSourcesEqual = (src1: string | string[], src2: string | string[]) => {
    if (typeof src1 === 'string' && typeof src2 === 'string') {
        return src1 === src2;
    }

    const sources1 = Array.isArray(src1) ? src1 : [src1];
    const sources2 = Array.isArray(src2) ? src2 : [src2];

    if (sources1.length !== sources2.length) {
        return false;
    }

    return sources1.every((s1, i) => s1 === sources2[i]);
};
